import {Account, AccountCreateDTO, AccountUpdateDTO} from "../models/account";
import {authFetch} from "../auth/authFetch";

const BASE_URL = "/api/accounts";

export async function loginAccount({username, password}: { username: string; password: string }): Promise<Account> {
    const body = new URLSearchParams({username, password});

    const res = await authFetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        body
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<Account>;
}

export async function registerAccount(dto: AccountCreateDTO): Promise<Account> {
    const res = await authFetch(BASE_URL, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<Account>;
}

export async function getAccountById(id: number): Promise<Account | null> {
    return getAccount(`${BASE_URL}/id/${id}`);
}

export async function getAccountByAccountCode(accountCode: string): Promise<Account | null> {
    return getAccount(`${BASE_URL}/accountCode/${accountCode}`);
}

async function getAccount(url: string): Promise<Account | null> {
    const res = await authFetch(url);

    if (res.status === 404) {
        return null;
    }

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<Account>;
}

export async function checkUsername(username: string): Promise<boolean> {
    const res = await authFetch(`${BASE_URL}/exists?username=${encodeURIComponent(username)}`);

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<boolean>;
}

export async function checkPassword(username: string, password: string): Promise<boolean> {
    const body = new URLSearchParams({username, password});

    try {
        const res = await authFetch(`${BASE_URL}/login`, {
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            body
        });

        if (!res.ok) {
            return false;
        }

        const data = await res.json();
        return data !== null;
    } catch {
        return false;
    }
}

export async function updateAccount(id: number, dto: AccountUpdateDTO): Promise<Account> {
    const res = await authFetch(`${BASE_URL}/${id}`, {
        method: "PATCH",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<Account>;
}

export async function deleteAccount(id: number): Promise<void> {
    const res = await authFetch(`${BASE_URL}/${id}`, {
        method: "DELETE"
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }
}
